<template>
  <div class="price_item_container">
    <div class="name">{{ data.name }}</div>
    <div class="price">¥ <span>{{ data.price }}</span> /人</div>
    <div class="num">
      <i class="fa fa-minus-circle" :class="{disabled: num2<=0}" @click="minus"></i>
      <span>{{ num2 }}</span>
      <i class="fa fa-plus-circle" @click="plus"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'price-item',
  props: ['data', 'num'],
  data () {
    return {
      num2: 0
    }
  },
  components: {
  },
  created () {
    this.num2 = this.num
  },
  methods: {
    minus () {
      if (this.num2 === 0) return false
      this.num2 -= 1
      this.$emit('numChange', this.data, this.num2)
    },
    plus () {
      this.num2 += 1
      this.$emit('numChange', this.data, this.num2)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "@/assets/css/mixin.scss";
  .price_item_container {
    height: rem(80);
    padding: 0 rem(18);
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: rem(25);
    border-bottom: 1px solid #f5f5f5;
    .name {
      width: rem(210);
    }
    .price {
      width: rem(200);
      text-align: center;
      span {
        color: #ff931b;
      }
    }
    .num {
      padding-right: rem(30);
      width: rem(120);
      display: flex;
      justify-content: space-between;
      align-items: center;
      i {
        color: #ff931b;
        font-size: rem(32);
        &.disabled {
          color: #999;
        }
      }
      span {
        text-align: center;
      }
    }
  }
</style>
